// extracted by mini-css-extract-plugin
module.exports = {"checkmarkImage":"_755ab59c","servicesTableContainer":"_2b15d7df","servicesTable":"_206d3118","serviceCell":"_d4803cb3","serviceHeadCell":"_463c0bb"};